import type { HumanReadableTimeProps } from '../types'

import React, { useReducer } from 'react'
import { useInterval } from 'react-use'

export function HumanReadableTime({ value }: HumanReadableTimeProps): JSX.Element {
  const diff = Date.now() - value.getTime()
  const [, forceRerender] = useReducer(x => x * -1, 1)

  let interval: number | null
  let result: React.ReactNode

  switch (true) {
    case diff < 0: {
      result = 'in the future'
      interval = 1000
      break
    }

    case diff < 1000: {
      result = 'just now'
      interval = 5000
      break
    }

    case diff < 10 * 1000: {
      result = 'a few seconds ago'
      interval = 1000
      break
    }

    case diff < 60 * 1000: {
      result = `${Math.floor(diff / 1000)} seconds ago`
      interval = 1000
      break
    }

    case diff < 60 * 60 * 1000: {
      const minutes = Math.floor(diff / 1000 / 60)
      result = `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`
      interval = 60 * 1000
      break
    }

    case diff < 24 * 60 * 60 * 1000: {
      const hours = Math.floor(diff / 1000 / 60 / 60)
      result = `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`
      interval = 60 * 60 * 1000
      break
    }

    default: {
      const days = Math.floor(diff / 1000 / 60 / 60 / 24)
      result = `${days} ${days === 1 ? 'day' : 'days'} ago`
      interval = 24 * 60 * 60 * 1000
      break
    }
  }

  useInterval(() => {
    forceRerender()
  }, interval)

  return <>{result}</>
}
